import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PageData } from '@core/bean/page-data';

@Injectable({
  providedIn: 'root'
})
export class ProgrammeService extends BaseService{
  HEADER_NAME_TOTALCOUNT = 'X-Total-Count';

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return "api/sup-ass-plan";
  }

  getOneData(obj: object) {
    let params = new HttpParams();
    let data = '';
    for (var key in obj) {
      data += '&' + key + '=' + obj[key];
    }
    data ='?'+data.slice(1);
    return new Observable((observable) => {
      this.http.get(`api/sup-ass-plan/code${data}`, {
        observe: 'response',//完整数据返回，包括抬头
        params,
      }).pipe(
        tap(() => this.log('query object')),
        catchError(this.handleError('get any', [])),
      ).subscribe((httpResponse: HttpResponse<any>) => {
        let totalCount = httpResponse.headers.get(this.HEADER_NAME_TOTALCOUNT);
        let data = httpResponse.body;
        let pageData = new PageData(Number.parseInt(totalCount), data);
        observable.next(pageData);
      }, error => {
        observable.error(error);
      }, () => {
        observable.complete();
      });
    });
  }

  deleteData(id:any[]):Observable<any> {
    let params = new HttpParams();
    for (let item of id) {
      params = params.append("id", item);
    }
    return this.http.delete<any>(this.getUrl()+'/code', {
      headers: httpOptions.headers,
      params: params
    }).pipe(
      tap(_ => this.log(`deleted object list id=${id}`)),
      catchError(this.handleError<any>('delet object list'))
    );
  }

}
